export let TypeImage;

(function (TypeImage) {
  TypeImage["ReqImageConfigure"] = "REQ.IMAGE.CONFIGURE";
  TypeImage["ReqImagePick"] = "REQ.IMAGE.PICK";
  TypeImage["ResImagePick"] = "RES.IMAGE.PICK";
})(TypeImage || (TypeImage = {}));